var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, truncateWords } from '@shapeable/utils';
var cls = classNames('markdown-content');
import { breakpoints } from '@shapeable/theme';
import { reduce } from 'lodash';
import MarkdownToJSX from 'markdown-to-jsx';
import { Content } from './content';
import { useEmbedComponents } from '../hooks/use-embed-components';
export var MARKDOWN_CONTENT_REPLACEMENTS = {
  'CO2': 'CO<sub>2</sub>'
};
export var MarkdownContentDefaultProps = {
  replacements: MARKDOWN_CONTENT_REPLACEMENTS
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: inherit;\n\n    a {\n      hyphens: auto;\n      word-break: break-word;\n      word-wrap: break-word;\n    }\n\n    sub {\n      line-height: 0;\n    }\n    \n    ul, ol, p {\n      font-size: 1em;\n      margin-top: 0;\n      margin-bottom: 2em;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n  "], ["\n    font-size: 1em;\n    font-weight: inherit;\n\n    a {\n      hyphens: auto;\n      word-break: break-word;\n      word-wrap: break-word;\n    }\n\n    sub {\n      line-height: 0;\n    }\n    \n    ul, ol, p {\n      font-size: 1em;\n      margin-top: 0;\n      margin-bottom: 2em;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(Content)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var MarkdownContent = function (props) {
  var className = props.className,
    size = props.size,
    replacements = props.replacements,
    maxWords = props.maxWords;
  var embedComponents = useEmbedComponents();
  var overrides = __assign(__assign({}, embedComponents || {}), props.embedComponents || {});
  var text = props.text && props.text.replace(/\\/ig, '') || '';
  if (maxWords) {
    text = truncateWords(text, {
      max: maxWords
    });
  }
  var finalText = reduce(replacements, function (acc, replaceWith, replace) {
    return acc.replace(new RegExp(replace, 'ig'), replaceWith);
  }, text);
  return React.createElement(My.Container, {
    size: size,
    className: cls.name(className)
  }, React.createElement(MarkdownToJSX, {
    options: {
      overrides: overrides
    }
  }, finalText));
};
MarkdownContent.defaultProps = MarkdownContentDefaultProps;
MarkdownContent.cls = cls;
var templateObject_1, templateObject_2;